import type { Dispatch, SetStateAction } from 'react';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getIsHomePath } from '../../../../store/selectors/router';
import { MIN_NUM_OF_FLIGHTS_TO_SHOW_FILTERS } from './constants';

// eslint-disable-next-line import/no-cycle
import { getUnfilteredFlightsCount } from './selectors';

export const useShowFilters = (): [
  boolean,
  Dispatch<SetStateAction<boolean>>,
] => {
  const [showFilters, setShowFilters] = useState(false);

  const [areEnoughFlights, setAreEnoughFlights] = useState(false);

  const unfilteredFlightsCount = useSelector(getUnfilteredFlightsCount);

  useEffect(() => {
    if (unfilteredFlightsCount >= MIN_NUM_OF_FLIGHTS_TO_SHOW_FILTERS) {
      setAreEnoughFlights(true);
    }
  }, [setAreEnoughFlights, unfilteredFlightsCount]);

  const isHomePath = useSelector(getIsHomePath);

  useEffect(() => {
    if (areEnoughFlights) {
      setShowFilters(isHomePath);
    }
  }, [areEnoughFlights, isHomePath]);

  return [showFilters, setShowFilters];
};
